const n = (a) => typeof a == "string" && (a === "lg" || a === "md" || a === "sm" || a === "xs" || a === "2xs" || a === "3xs"), g = (a) => n(a) ? a : "md", t = (a) => typeof a == "string" && (a === "gray" || a === "primary" || a === "success" || a === "error" || a === "warning" || a === "gray-blue" || a === "blue-light" || a === "blue" || a === "indigo" || a === "purple" || a === "pink" || a === "rose" || a === "orange-dark"), m = (a) => t(a) ? a : "gray", e = (a) => typeof a == "string" && (a === "blue" || a === "red" || a === "gray" || a === "orange" || a === "green"), s = (a) => e(a) ? a : "gray";
export {
  s as fallbackBasicColor,
  m as fallbackCommonColor,
  g as fallbackCommonSize,
  e as validateBasicColor,
  t as validateCommonColor,
  n as validateCommonSize
};
